module.exports = __webpack_public_path__ + "static/media/logosFooterComposition.bcabde52.webp";